import { api as dragoonApi } from '@apis/dragoon/api';
import { api as fistoApi } from '@apis/fisto/api';
import { api as rammanApi } from '@apis/ramman/api';
import { api as rioblast } from '@apis/rioblast/api';
import { configureStore } from '@reduxjs/toolkit';
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux';

import rootReducer, { type RootState } from './rootReducer';
import { apiSkeletor } from './skeletor/skeletorApi';

export type PreloadedState = Partial<RootState>;

const createStore = (preloadedState: PreloadedState) => {
  return configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(
        apiSkeletor.middleware,
        rammanApi.middleware,
        rioblast.middleware,
        dragoonApi.middleware,
        fistoApi.middleware,
      ),
    enhancers: getDefaultEnhancers =>
      getDefaultEnhancers(
        import.meta.env.MODE === 'test' ? { autoBatch: false } : undefined,
      ),
    devTools: import.meta.env.DEV,
    preloadedState,
  });
};

export type AppStore = ReturnType<typeof createStore>;

export type AppDispatch = ReturnType<typeof createStore>['dispatch'];

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default createStore;
